import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

let authUserId = null;
export function setAuthUserId(id) { authUserId = id; }

export function getUserId() {
  if (authUserId) return authUserId;
  let id = localStorage.getItem("pv_user_id");
  if (!id) {
    id = "u_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("pv_user_id", id);
  }
  return id;
}

// ---- Auth ----
export const registerUser = (payload) => api.post("/auth/register", payload).then((r) => r.data);
export const loginUser = (payload) => api.post("/auth/login", payload).then((r) => r.data);
export const googleSession = (session_id, ref) => api.post("/auth/google/session", { session_id, ref }).then((r) => r.data);
export const fetchMe = () => api.get("/auth/me").then((r) => r.data);
export const logoutUser = () => api.post("/auth/logout").then((r) => r.data);
export const deleteAccount = () => api.delete("/auth/me").then((r) => r.data);
export const getReferral = () => api.get("/referral/me").then((r) => r.data);

// ---- Payments ----
export const createCheckout = (payload) => api.post("/payments/checkout", payload).then((r) => r.data);
export const getPaymentStatus = (sid) => api.get(`/payments/status/${sid}`).then((r) => r.data);
export const createBillingPortal = (payload) => api.post("/payments/portal", payload).then((r) => r.data);
export const forgotPassword = (payload) => api.post("/auth/forgot-password", payload).then((r) => r.data);
export const resetPassword = (payload) => api.post("/auth/reset-password", payload).then((r) => r.data);

// ---- Plans / cleanses ----
export const generatePlan = (payload) => api.post("/plans/generate", payload).then((r) => r.data);
export const savePlan = (payload) => api.post("/plans", { tz: Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC", ...payload }).then((r) => r.data);
export const listPlans = (userId) => api.get("/plans", { params: { userId } }).then((r) => r.data);
export const getPlan = (id) => api.get(`/plans/${id}`).then((r) => r.data);
export const startPlan = (id, userId) => api.post(`/plans/${id}/start`, null, { params: { userId } }).then((r) => r.data);
export const updateBought = (id, userId, bought) => api.patch(`/plans/${id}/bought`, { bought }, { params: { userId } }).then((r) => r.data);
export const deletePlan = (id, userId) => api.delete(`/plans/${id}`, { params: { userId } }).then((r) => r.data);
export const updateProgress = (planId, payload) => api.put(`/plans/${planId}/progress`, payload).then((r) => r.data);
export const getProgress = (planId, userId) => api.get(`/plans/${planId}/progress`, { params: { userId } }).then((r) => r.data);
export const getLibrary = () => api.get("/library").then((r) => r.data);
export const getArticles = () => api.get("/articles").then((r) => r.data);
export const getArticle = (slug) => api.get(`/articles/${slug}`).then((r) => r.data);
export const getOptions = () => api.get("/options").then((r) => r.data);
export const getNextPlan = (userId) => api.get("/next-plan", { params: { userId } }).then((r) => r.data.suggestion);
export const dismissNextPlan = (id, userId) => api.post(`/plans/${id}/dismiss-next`, { userId }).then((r) => r.data);
export const endPlan = (id, userId) => api.post(`/plans/${id}/end`, { userId }).then((r) => r.data);
export const updatePlanTimes = (id, payload) => api.put(`/plans/${id}/times`, payload).then((r) => r.data);

export default api;
